import dayjs from "~/lib/dayjs";

/**
 * Converts a timestamp to a human-readable relative time string.
 *
 * @param {number|string|Date} timestamp - The timestamp to format
 * @returns {string} Human-readable relative time (e.g., "5 minutes ago", "2 hours ago")
 */
export const formatTimeAgo = (timestamp) => dayjs(timestamp).fromNow();

export default { formatTimeAgo };
